import { Button } from '@sravni/react-design-system/lib/Button';
import { Heading } from '@sravni/react-design-system/lib/Typography';
import { useIsPhone } from '@sravni/react-utils';

import { sendOctoberPrizeDrawShowAllHistoriesEvent } from '@src/helpers/analyticsEvents';

import { getHistories } from '../constants';
import { OctoberPrizeDrawLayout } from '../OctoberPrizeDrawLayout';

import { OctoberPrizeDrawHistory } from './components';
import styles from './styles.module.scss';

export const OctoberPrizeDrawHistories = () => {
  const isMobile = useIsPhone();

  const handleShowAllHistories = () => {
    sendOctoberPrizeDrawShowAllHistoriesEvent();

    window.open('/promo/15-let-sravni/', '_blank');
  };

  return (
    <OctoberPrizeDrawLayout>
      <div className={styles.container}>
        <Heading className={styles.title} level={3}>
          Истории о том, как Сравни менял жизни
        </Heading>

        {getHistories(isMobile).map((step) => (
          <OctoberPrizeDrawHistory key={step.title} {...step} />
        ))}

        <Button size={60} className={styles.button} onClick={handleShowAllHistories}>
          Смотреть все истории
        </Button>
      </div>
    </OctoberPrizeDrawLayout>
  );
};
